export function waitForElementToDisplay(selector, limit = 50) {
  return new Promise((resolve, reject) => {
    let elementInterval;
    let attempts = 0;
    function checkForElement() {
      attempts++;
      const elements = Array.from(document.querySelectorAll(selector));
      if (
        elements != null
        && elements.length > 0
      ) {
        clearInterval(elementInterval);
        return resolve(elements);
      } else if (attempts > limit) {
        clearInterval(elementInterval);
        return reject(`Could not find any elements associated with the selector string "${selector}" within ${limit} attempt(s).`);
      }
    }
    elementInterval = setInterval(checkForElement, 25);
  });
}